<template>
  <v-scroll-y-transition>
    <LayoutCard
      v-show="shouldShowBanner"
      background-color="#0076FF"
      rounded
      data-cy="multi-merchant-banner"
      class="mx-1 banner-card"
    >
      <div class="d-flex flex-row">
        <div class="d-flex flex-row align-flex-start">
          <img
            :src="require(`@/assets/icons/orders-bell.svg`)"
            class="mr-3"
            width="20"
            height="20"
          />
        </div>
        <div>
          <div class="tp-text-subtitle-semibold white--text pb-1 pr-6">
            {{ $t('screens.order.multiMerchantBannerHeader') }}
          </div>
          <div class="tp-text-body white--text">
            {{ $t('screens.order.multiMerchantBannerBody') }}
          </div>
        </div>
      </div>
      <v-icon color="white" small class="close-icon" @click="dismissBanner">
        mdi-close
      </v-icon>
      <CtaButton class="mt-3" color="white" white x-small @click="ctaClicked">
        {{ $t('screens.order.multiMerchantBannerCta') }}
      </CtaButton>
    </LayoutCard>
  </v-scroll-y-transition>
</template>

<script>
import LayoutCard from '@/components/LayoutCard.vue';
import CtaButton from '@/components/Button.vue';
import cookies from '@/utils/cookies';

export default {
  name: 'MultiMerchantBanner',
  components: {
    LayoutCard,
    CtaButton,
  },
  data() {
    return {
      isVisible: false,
      isDismissed: false,
    };
  },
  computed: {
    shouldShowBanner() {
      return this.isVisible && !this.isDismissed;
    },
  },
  mounted() {
    this.isDismissed = this.getBannerDismissedState();

    if (!this.isDismissed) {
      setTimeout(() => {
        this.isVisible = true;
      }, 200);
    }
  },
  methods: {
    ctaClicked() {
      this.$emit('cta-click');
    },
    dismissBanner() {
      this.isDismissed = true;
      this.setBannerDismissedState(true);
    },
    getBannerDismissedState() {
      const dismissed = cookies.getCookie('multiMerchantBannerDismissed');
      return dismissed === 'true';
    },
    setBannerDismissedState(dismissed) {
      this.isVisible = false;
      cookies.setCookie({
        name: 'multiMerchantBannerDismissed',
        value: dismissed.toString(),
        hours: 300 * 24,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-card {
  position: relative;
}

.close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>
